import React from "react";
import { useAuthUser } from "../auth/useAuthUser";

export default function UserInfo() {
  const { user, loading } = useAuthUser();
  if (loading || !user) return null;
  return (
    <div style={{margin:'0 16px',fontSize:14,display:'flex',alignItems:'center'}}>
      <span>已登录：</span>
      <b>{user.userDetails}</b>
      <span style={{marginLeft:8,color:'#888'}}>{user.identityProvider}</span>
      <button
        style={{marginLeft:16,padding:'2px 12px',fontSize:13,cursor:'pointer'}}
        onClick={() => window.location.href = '/.auth/logout'}
      >退出</button>
    </div>
  );
}
